import { Car, Wrench, Laptop, Smartphone, Shirt } from 'lucide-react'

/**
 * What this company calls its asset register, and whether its board draws it.
 *
 * 'asset' is the stored word — tables, routes, audit actions, the asset_admin role — and
 * nothing a person reads should have to say it. Every caption goes through here, so a company
 * that calls the register "Fleet" and one item a "vehicle" sees those words on the board, in
 * Settings and in every button, with no data touched. Mirrors lib/modes.js.
 *
 * Defaults must match ASSET_DEFAULTS in server/src/repos/assets.js. The server is the source
 * of truth and always sends a resolved caption; these cover the first paint before /api/me
 * has landed.
 */
const FALLBACK = { name: 'Assets', unitName: 'asset' }

/** The register's name: "Fleet". `assets` is the map from /api/me. */
export function assetsName(assets) {
  return assets?.name || FALLBACK.name
}

/** One item: "vehicle". For "Add vehicle", "Retire vehicle". */
export function assetUnit(assets) {
  return assets?.unitName || FALLBACK.unitName
}

/**
 * Whether the board draws the fleet. `=== true` rather than `!== false`, the opposite of the
 * modes helper, and for the opposite reason: off is the default and most companies never turn
 * this on, so the first paint before /api/me lands must not flash a band that is about to
 * disappear.
 */
export function assetsOnBoard(assets) {
  return assets?.onBoard === true
}

/**
 * The glyph for each stored icon key.
 *
 * One table, shared by the register in Settings and the bands on the board, because two
 * copies of this mapping would eventually disagree about what a 'phones' group looks like.
 * The database stores only the key — it says which KIND of thing a group holds — and this
 * decides what that looks like, so a redesign is a change here rather than a data migration.
 * Keep the keys in step with the CHECK in migration 012 and ASSET_ICONS in repos/assets.js.
 */
const ASSET_ICON_GLYPHS = {
  cars: Car,
  tools: Wrench,
  computers: Laptop,
  phones: Smartphone,
  clothing: Shirt,
}

/** Falls back to the wrench, which is also the column's default. */
export const glyphFor = (key) => ASSET_ICON_GLYPHS[key] || Wrench
